module.exports = __webpack_public_path__ + "static/media/next.580ab15f.svg";